export const apiRoutes = {
  login: "/auth"
};
